import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var getSizes = function(size, theme, mq) {
    if (Array.isArray(size)) {
        var responsiveSizeForMedia = size.find(function(param) {
            var _param = _sliced_to_array(param, 2), _breakpoint = _param[1];
            return _breakpoint === mq;
        });
        if (responsiveSizeForMedia) {
            var _responsiveSizeForMedia = _sliced_to_array(responsiveSizeForMedia, 1), responsiveSize = _responsiveSizeForMedia[0];
            return responsiveSize === "full" ? "100%" : theme.spacing[responsiveSize];
        }
        return null;
    }
    return size === "full" ? "100%" : theme.spacing[size];
};
var IconWrapper = /*#__PURE__*/ styled("div", {
    target: "e1lyeg8y0"
})("& > svg{border-radius:0;padding:", function(param) {
    var indent = param.indent, theme = param.theme;
    return "0 ".concat(theme.spacing[indent]);
}, ";fill:", function(param) {
    var color = param.color, theme = param.theme;
    return color === "current" ? "current" : theme.color[color];
}, ";width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme);
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme);
}, ";", Theme.mq("sm"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "sm");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "sm");
}, ";}", Theme.mq("md"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "md");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "md");
}, ";}", Theme.mq("lg"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "lg");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "lg");
}, ";}", Theme.mq("xl"), "{width:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "xl");
}, ";height:", function(param) {
    var size = param.size, theme = param.theme;
    return getSizes(size, theme, "xl");
}, ";}}");
export { IconWrapper };
